/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M5.25 5.75a.75.75 0 0 0 0 1.5h8.25a.75.75 0 0 0 0-1.5H5.25ZM4.5 11a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 0 1.5H5.25A.75.75 0 0 1 4.5 11ZM17.5 19.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.25 3.75v5.587c1.4333.3385 2.5 1.6262 2.5 3.163V14h.75c1.1046 0 2 .8954 2 2v4c0 2.2091-1.7909 4-4 4h-4c-1.6787 0-3.1159-1.0341-3.7092-2.5H4.25C2.179 21.5.5 19.8211.5 17.75v-14C.5 1.679 2.179 0 4.25 0H14.5c2.0711 0 3.75 1.679 3.75 3.75ZM14.5 1.5c1.2426 0 2.25 1.0074 2.25 2.25v5.587c-1.4333.3385-2.5 1.6262-2.5 3.163V14h-.75c-1.1046 0-2 .8954-2 2v4H4.25C3.0074 20 2 18.9926 2 17.75v-14C2 2.5074 3.0074 1.5 4.25 1.5H14.5Zm4.75 11V14h-3.5v-1.5c0-.9665.7835-1.75 1.75-1.75s1.75.7835 1.75 1.75Zm2.25 3a.5.5 0 0 1 .5.5v4c0 1.3807-1.1193 2.5-2.5 2.5h-4c-1.3807 0-2.5-1.1193-2.5-2.5v-4a.5.5 0 0 1 .5-.5h8Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuConfigsSecrets'
);
